import DateUtil from '../utils/DateUtil';
import {TSKantonCode} from './enums/TSKantonCode';
import {TSSchadenfallHerkunft} from './enums/TSSchadenfallHerkunft';
import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';
import {TSSprache} from './enums/TSSprache';
import TSSchadenfall from './TSSchadenfall';
import moment = require('../../../node_modules/moment/moment');

export default class TSSchadenfallDTO {
    private _schadenfallId: string;
    private _schadenfallHerkunft: TSSchadenfallHerkunft;
    private _fallNummer: number;
    private _gesuchstellerName: string;
    private _ereignis: string;
    private _amtsstelleName: string;
    private _ort: string;
    private _kanton: TSKantonCode;
    private _korrespondenzsprache: TSSprache;
    private _gesuchsdatum: moment.Moment | undefined;
    private _ereignisdatum: moment.Moment | undefined;
    private _status: TSSchadenfallStatus;
    private _verantwortlicher: string;
    private _geschaetzteKosten: number | undefined;
    private _totalSchaetzung: number | undefined;
    private _isOverdue: boolean | undefined;
    private _newInStatus: boolean | undefined;

    public get fallNummer(): number {
        return this._fallNummer;
    }

    public set fallNummer(value: number) {
        this._fallNummer = value;
    }

    public get schadenfallHerkunft(): TSSchadenfallHerkunft {
        return this._schadenfallHerkunft;
    }

    public set schadenfallHerkunft(value: TSSchadenfallHerkunft) {
        this._schadenfallHerkunft = value;
    }

    public get gesuchstellerName(): string {
        return this._gesuchstellerName;
    }

    public set gesuchstellerName(value: string) {
        this._gesuchstellerName = value;
    }

    public get ereignis(): string {
        return this._ereignis;
    }

    public set ereignis(value: string) {
        this._ereignis = value;
    }

    public get amtsstelleName(): string {
        return this._amtsstelleName;
    }

    public set amtsstelleName(value: string) {
        this._amtsstelleName = value;
    }

    public get ort(): string {
        return this._ort;
    }

    public set ort(value: string) {
        this._ort = value;
    }

    public get gesuchsdatum(): moment.Moment | undefined {
        return this._gesuchsdatum;
    }

    public set gesuchsdatum(value: moment.Moment | undefined) {
        this._gesuchsdatum = value;
    }

    public get ereignisdatum(): moment.Moment | undefined {
        return this._ereignisdatum;
    }

    public set ereignisdatum(value: moment.Moment | undefined) {
        this._ereignisdatum = value;
    }

    public get status(): TSSchadenfallStatus {
        return this._status;
    }

    public set status(value: TSSchadenfallStatus) {
        this._status = value;
    }

    public get verantwortlicher(): string {
        return this._verantwortlicher;
    }

    public set verantwortlicher(value: string) {
        this._verantwortlicher = value;
    }

    public get schadenfallId(): string {
        return this._schadenfallId;
    }

    public set schadenfallId(value: string) {
        this._schadenfallId = value;
    }

    public getFallnummerWithZeros(): string {
        return TSSchadenfall.calculateFallnummerWithZeros(this._fallNummer);
    }

    public get kanton(): TSKantonCode {
        return this._kanton;
    }

    public set kanton(value: TSKantonCode) {
        this._kanton = value;
    }

    public get geschaetzteKosten(): number | undefined {
        return this._geschaetzteKosten;
    }

    public set geschaetzteKosten(value: number | undefined) {
        this._geschaetzteKosten = value;
    }

    public get totalSchaetzung(): number | undefined {
        return this._totalSchaetzung;
    }

    public set totalSchaetzung(value: number | undefined) {
        this._totalSchaetzung = value;
    }

    public get korrespondenzsprache(): TSSprache {
        return this._korrespondenzsprache;
    }

    public set korrespondenzsprache(value: TSSprache) {
        this._korrespondenzsprache = value;
    }

    public get newInStatus(): boolean | undefined {
        return this._newInStatus;
    }

    public set newInStatus(value: boolean | undefined) {
        this._newInStatus = value;
    }

    public get isOverdue(): boolean | undefined {
        return this._isOverdue;
    }

    public set isOverdue(value: boolean | undefined) {
        this._isOverdue = value;
    }

    deserialize(restObject: any): TSSchadenfallDTO {
        this.schadenfallId = restObject.schadenfallId;
        this.fallNummer = restObject.fallNummer;
        this.gesuchstellerName = restObject.gesuchstellerName;
        this.ereignis = restObject.ereignis;
        this.amtsstelleName = restObject.amtsstelleName;
        this.ort = restObject.ort;
        this.kanton = restObject.kanton;
        this.korrespondenzsprache = restObject.korrespondenzsprache;
        this.gesuchsdatum = DateUtil.localDateToMoment(restObject.gesuchsdatum);
        this.ereignisdatum = DateUtil.localDateToMoment(restObject.ereignisdatum);
        this.status = restObject.status;
        this.verantwortlicher = restObject.verantwortlicher;
        this.geschaetzteKosten = restObject.geschaetzteKosten;
        this.isOverdue = restObject.isOverdue;
        this.newInStatus = restObject.newInStatus;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSchadenfallDTO.ts